(function () {
  function normalizedText(element) {
    return (element && element.textContent ? element.textContent : '')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function parseMarker(element) {
    var text = normalizedText(element);
    var match = text.match(/^\[([a-z0-9_:-]+)\]$/i);
    if (!match) return null;

    var parts = match[1].toLowerCase().split(':');
    var base = parts.shift();
    if (!/^(products_[45]|slideshow_[45])$/.test(base)) return null;

    var width = null;
    parts.forEach(function (option) {
      if (option === 'text' || option === 'wide' || option === 'full') width = option;
    });

    return { base: base, width: width };
  }

  function applyWidth(block, width) {
    if (!width) return;
    block.classList.remove('is-width-wide', 'is-width-full', 'is-width-text');
    block.classList.add('is-width-' + width);
    block.dataset.editorialWidth = width;
  }

  function updateSlideshow(slideshow) {
    var track = slideshow.querySelector('[data-slideshow-track]');
    var slides = Array.prototype.slice.call(slideshow.querySelectorAll('[data-slideshow-slide]'));
    var dots = Array.prototype.slice.call(slideshow.querySelectorAll('[data-slideshow-index]'));
    if (!track || slides.length === 0) return;

    var width = track.clientWidth || 1;
    var activeIndex = Math.round(track.scrollLeft / width);
    activeIndex = Math.max(0, Math.min(activeIndex, slides.length - 1));

    dots.forEach(function (dot, index) {
      var active = index === activeIndex;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-current', active ? 'true' : 'false');
    });
  }

  function initializeSlideshow(slideshow) {
    if (!slideshow || slideshow.dataset.extraSlideshowInitialized === 'true') return;
    var track = slideshow.querySelector('[data-slideshow-track]');
    if (!track) return;

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        updateSlideshow(slideshow);
        ticking = false;
      });
    });

    slideshow.dataset.extraSlideshowInitialized = 'true';
    updateSlideshow(slideshow);
  }

  function replaceMarkers(scope) {
    (scope || document).querySelectorAll('[data-editorial-content]').forEach(function (body) {
      var templateRoot = body.closest('.editorial-article__content') || document;

      Array.prototype.slice.call(body.children).forEach(function (block) {
        var marker = parseMarker(block);
        if (!marker) return;

        var selector = 'template[data-editorial-template="' + marker.base + '"]';
        var template = templateRoot.querySelector(selector) || document.querySelector(selector);

        if (!template || !template.content.firstElementChild) {
          block.remove();
          return;
        }

        var replacement = template.content.firstElementChild.cloneNode(true);
        applyWidth(replacement, marker.width);
        block.replaceWith(replacement);

        if (replacement.matches('[data-editorial-slideshow]')) initializeSlideshow(replacement);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () { replaceMarkers(document); });
  document.addEventListener('shopify:section:load', function (event) { replaceMarkers(event.target); });
  window.addEventListener('resize', function () {
    document.querySelectorAll('[data-editorial-slideshow]').forEach(updateSlideshow);
  });
})();